import { HttpParams } from '@angular/common/http';

import { toHTTPParam } from '../../../../core';
import { periodicidadeMensal } from '../integration-periodicidade';

export class IntegrationCarteiraPedido {
    periodicidade: number;
    dataInicialBase: Date;

    constructor() {
        this.periodicidade = periodicidadeMensal.id;
    }

    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Periodicidade
        if (this.periodicidade) {
            params = params.append('periodicidade', this.periodicidade.toString());
        }
        // Data Inicial Base
        if (this.dataInicialBase) {
            params = params.append('dataInicialBase', toHTTPParam(this.dataInicialBase));
        }
        // Execução manual
        params = params.append('manual', 'true');

        return params;
    }

    clear() {
        this.periodicidade = periodicidadeMensal.id;
        this.dataInicialBase = null;
    }
}
